import React from 'react';
import ReactDom from 'react-dom';
import SearchContainer from '@/user/components/fair/search_container';

const searchModal = document.getElementById('js-modal_search');
if (searchModal) {
    const fairDays = searchModal.dataset.fair_days;
    const fairTypes = searchModal.dataset.fair_types;
    const startOfMonth = searchModal.dataset.start_month;
    const webReservePeriodDate = searchModal.dataset.web_reserve_period;
    const fairsTotal = searchModal.dataset.fair_total;
    const initialDate = searchModal.dataset.initial_date;
    const initialFairType = searchModal.dataset.initial_fair_type;
    
    ReactDom.render(
        <>
            <SearchContainer
                fairDays={JSON.parse(fairDays)}
                fairTypes={JSON.parse(fairTypes)}
                webReservePeriodDate={webReservePeriodDate}
                startOfMonth={startOfMonth}
                fairsTotal={parseInt(fairsTotal)}
                initialDate={JSON.parse(initialDate)}
                initialFairType={JSON.parse(initialFairType)}
            />
        </>,
        searchModal
    );
}
